module.exports = __webpack_public_path__ + "img/banner1.592ba034.jpg";